import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";

@Component({
  standalone: true,
  selector: "app-prefix-gt7",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-gt7.component.html",
  styleUrl: "./prefix-gt7.component.less",
})
export class PrefixGt7Component extends PrefixComponent<string> {
  public max: Max;

  public constructor() {
    super({ updateOn: "blur" });
    this.max = 999999999999;
    this.characters = ALLOWED_CHARACTERS["gt7"];
  }
}
